import React from "react";
import Toast from "@nykaa/ui-components/Toast";
import Button from "@nykaa/ui-components/Button";
import { trackCheckButtonClickOnToast } from "layouts/Payment/common/dependencies/tracking";
import { ToastWrapper } from "./assets/styles";
import { platformNames } from "constants/index";

/**
 *
 * @description DeliveryToast component is to show toaster on the checkout page whenever the address is changed by the user or new address is addded with updated delivery dates
 * is rendered on the basis of the state and isToastVisible condition
 * we are doing AB2 experiment for men
 */
interface DeliveryToastProps {
  isToastVisible?: boolean;
  toastDeliveryMessage: string;
  setIsCheckButtonClickedOnToast: React.Dispatch<React.SetStateAction<boolean>>;
  setIsScrollToEddElement: React.Dispatch<React.SetStateAction<boolean>>;
  setIsToastVisible: React.Dispatch<React.SetStateAction<boolean>>;
}
export const DeliveryToast = (props: DeliveryToastProps) => {
  const {
    isToastVisible,
    toastDeliveryMessage,
    setIsCheckButtonClickedOnToast,
    setIsScrollToEddElement,
    setIsToastVisible,
  } = props;

  if (isToastVisible) {
    return (
      <>
        {__PLATFORM__ === platformNames.NIKE ? (
          <ToastWrapper>{toastDeliveryMessage}</ToastWrapper>
        ) : (
          <div className="layout vertical mrl20">
            <Toast
              hideTimer={true}
              message={toastDeliveryMessage}
              onDismiss={() => {}}
              variant="single"
              verticalOffset={98}
              isChildren={true}
            >
              <Button
                kind="tertiary"
                onClick={() => {
                  setIsCheckButtonClickedOnToast(true);
                  setIsScrollToEddElement(true);
                  setIsToastVisible(false);
                  trackCheckButtonClickOnToast();
                }}
                shape="default"
                size="small"
              >
                Check
              </Button>
            </Toast>
          </div>
        )}
      </>
    );
  }
  return null;
};
